import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
import { draftLogicTextsPath } from '~/business-logic/draftLogic';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../../EditableTableCell/EditableTableCell';
import { additionalRecipientsModalOptions, clientAdditionalRecipientsModalOptions, recipientsCellAvailability } from './AdditionalRecipientsCell.utils';
export const GetAdditionalRecipientsCellTID = (parentTestId)=>getTestIds(parentTestId);
export function AdditionalRecipientsCell(param) {
    let { draft, contact, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { CRM_DRAFT_CONTACTS } = useFeatureFlags();
    const { AdditionalRecipientsCellTestIds } = GetAdditionalRecipientsCellTID();
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const { t: validationTexts } = useLocaleKeys(draftLogicTextsPath);
    const numReviewers = draft.reviewers().length;
    const modalArgs = {
        title: draftCellsTexts.additionalRecipients(),
        primaryContact: contact || undefined,
        validationTexts
    };
    const clientAware = CRM_DRAFT_CONTACTS === true;
    const availability = recipientsCellAvailability({
        draft,
        contact,
        clientAware,
        isDisabled,
        disabledTooltip,
        draftCellsTexts
    });
    const openRecipientsModal = ()=>onOpenModal(clientAware ? clientAdditionalRecipientsModalOptions(_object_spread_props(_object_spread({}, modalArgs), {
            testId: AdditionalRecipientsCellTestIds.ClientModal()
        })) : additionalRecipientsModalOptions(modalArgs));
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AdditionalRecipientsCellTestIds.Root(index),
        isDisabled: availability.isDisabled,
        disabledTooltip: availability.disabledTooltip,
        onClick: openRecipientsModal,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: AdditionalRecipientsCellTestIds.Count(index),
            skin: numReviewers ? 'standard' : 'secondary',
            children: numReviewers ? editTableTexts.additionalRecipientsCount({
                count: numReviewers
            }) : editTableTexts.notSet()
        })
    });
}
